<template>
  <div class="page-container">
    <router-link style="float: right" to="/overview">go back</router-link>
    <Countdown :timerDuration="timerDuration" />
  </div>
</template>

<script>
import Countdown from "@/components/FocusPage/Elements/Countdown";

export default {
  name: 'EggtimerPage',
  data() {
    return {
      timerDuration: 90
    };
  },
  mounted() {
    if ('time' in this.$route.params ) {
      let time = this.$route.params['time'];
      this.timerDuration = this.parseTimeparam(time);
    }

    this.toggleNavbarVisivility(true)
  },
  beforeDestroy() {
    this.toggleNavbarVisivility(false)
  },
  methods: {
    parseTimeparam(str) {
      console.log("got init time", str);
      /* Examples
      20
      20min
      2h
      1h020min
      20min4s
      9000s
      900sek
      300sec
      20Min
      */
      return parseFloat(str) * 60;
    },
    toggleNavbarVisivility(hide) {
      let element = document.querySelector("#app > nav");
      element.style.display = hide ? 'none' : '';
    }
  },
  components: {
    Countdown
  }
};
</script>

<style scoped>
.page-container {
  background-color: white;
  margin: 0;
  width: 100%;
  height: 100vh;
}
</style>
